module.exports = __webpack_public_path__ + "media/images/athletes/1705-72ecf6934afa29277965c5b7de32a784.png";